import { CardClipboardSecretText } from "components/details/CardClipboardSecretText";

import { SecretCardItemWrapper } from "./SecretCardItemWrapper";

import type { ReactNode } from "react";

export interface SecretCardItemProps {
  generateButton: ReactNode;
  secret: string | null;
  "data-testid"?: string;
  label?: ReactNode;
}

export function SecretCardItem({
  "data-testid": dataTestId,
  generateButton,
  label,
  secret,
}: SecretCardItemProps) {
  if (secret === null) {
    return (
      <SecretCardItemWrapper
        data-testid={dataTestId}
        generateButton={generateButton}
        label={label}
      />
    );
  }

  return (
    <SecretCardItemWrapper
      data-testid={dataTestId}
      generateButton={generateButton}
      label={label}
    >
      <CardClipboardSecretText
        data-testid={dataTestId ? `${dataTestId}-secret-text` : undefined}
        text={secret}
      />
    </SecretCardItemWrapper>
  );
}
